import React from "react";
import Card from "./Card";
import styles from "./CardContainer.module.css";
import { FaInbox } from "react-icons/fa";

export default function CardContainer({ allticketced, mantenimiento = [], usuario }) {
  // Normalize and combine records
  const regularTickets = (allticketced || []).map(t => ({ ...t, area: "Gest. TI", isMto: false }));

  const mtoRecords = (mantenimiento || []).flatMap(ticket =>
    (ticket.Ticketregistros || []).map(r => ({
      ...r,
      TicketId: ticket.id, // Mto uses 'id' instead of 'TicketId' in its root
      isMto: true,
      area: "Área Mto"
    }))
  );

  if (regularTickets.length === 0 && mtoRecords.length === 0) {
    return (
      <div className={styles.emptyState}>
        <FaInbox className={styles.emptyIcon} />
        <h3 className={styles.emptyTitle}>Sin registros</h3>
        <p className={styles.emptySubtitle}>No hay tickets en tu historial por el momento.</p>
      </div>
    );
  }

  // Filter both lists for closed (5) or canceled (6) status
  const filteredTickets = [
    ...regularTickets.filter((ticket) => ticket.EstadoId === 5 || ticket.EstadoId === 6),
    ...mtoRecords.filter((record) => record.EstadoId === 5 || record.EstadoId === 6)
  ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  // Combine ALL records for history lookup in Card.js
  const allRecords = [...regularTickets, ...mtoRecords];

  return (
    <div className={styles.container}>
      {filteredTickets.map((ticket, index) => {
        if (!ticket) return null;
        return (
          <Card
            key={`${ticket.isMto ? 'mto' : 'ti'}-${ticket.id || index}`}
            ticket={{ ...ticket, nombre: usuario?.nombre }}
            allticketced={allRecords}
          />
        );
      })}
    </div>
  );
}
